import { parseQueryString, replaceQueryString } from "./api";

export const processQueryParameters = () => {
  const qs = parseQueryString();

  const keys = Object.keys(qs);
  keys.forEach((x) => {
    if (x.startsWith("utm_")) {
      // tracking
      delete qs[x];
    }
    if (x === "pageVariantId") {
      delete qs[x];
    }
  });

  if (keys.length !== Object.keys(qs).length) {
    window.history.replaceState("{}", "", replaceQueryString(window.location.href, qs));
  }
};
